import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52aa9ca0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qzjjiancedetail-container" }
const _hoisted_2 = { class: "filter-date" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "table-list" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "重量(kg)：", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "倾角(°)：", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "转角(°)：", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "力矩(%)：", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "高度(m)：", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "风速(m/s)：", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "幅度(m)：", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openPopup && _ctx.openPopup(...args)))
      }, " 日期选择： " + _toDisplayString(_ctx.date ? _ctx.date : "请选择时间"), 1),
      _createElementVNode("img", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openPopup && _ctx.openPopup(...args))),
        src: require('./images/xiala.png')
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_van_pull_refresh, {
        modelValue: _ctx.refreshing,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.refreshing) = $event)),
        onRefresh: _ctx.onRefresh
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_list, {
            loading: _ctx.loading,
            "onUpdate:loading": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loading) = $event)),
            finished: _ctx.finished,
            "finished-text": "没有更多了",
            "loading-text": "正在加载,请稍后..",
            onLoad: _ctx.onLoad
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "list",
                  key: index
                }, [
                  _createElementVNode("div", null, _toDisplayString(item.deviceTime), 1),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", null, [
                        _hoisted_5,
                        _createElementVNode("span", null, _toDisplayString(item.load !== null ? item.load : "暂无数据"), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_6,
                        _createElementVNode("span", null, _toDisplayString(item.obliqueAngle !== null ? item.obliqueAngle : "暂无数据"), 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", null, [
                        _hoisted_7,
                        _createElementVNode("span", null, _toDisplayString(item.angle !== null ? item.angle : "暂无数据"), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_8,
                        _createElementVNode("span", null, _toDisplayString(item.percent !== null ? item.percent : "暂无数据"), 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", null, [
                        _hoisted_9,
                        _createElementVNode("span", null, _toDisplayString(item.height !== null ? item.height : "暂无数据"), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_10,
                        _createElementVNode("span", null, _toDisplayString(item.windSpeed !== null ? item.windSpeed : "暂无数据"), 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", null, [
                        _hoisted_11,
                        _createElementVNode("span", null, _toDisplayString(item.radius !== null ? item.radius : "暂无数据"), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["loading", "finished", "onLoad"])
        ]),
        _: 1
      }, 8, ["modelValue", "onRefresh"])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.show,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.show) = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_datetime_picker, {
          value: new Date(),
          "min-date": new Date(2019, 0, 1),
          type: "date",
          onConfirm: _ctx.fConfirmDate,
          onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.show = false))
        }, null, 8, ["value", "min-date", "onConfirm"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}